import { h } from 'preact';
import { ListSkeleton } from '../ListSkeleton';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'ListSkeleton',
  category: '⏳ Loading',
  description: 'Skeleton de lista com número customizável de linhas',
  usedIn: ['AgentesPage', 'ChatHubPage'],
  example: () => (
    <ListSkeleton rows={5} />
  ),
};
